$(document).ready(function() {
  $('.tab-menu li a').on('click', function(){
    var target = $(this).attr('data-rel');
    $('.tab-menu li a').removeClass('active');
    $(this).addClass('active');
    $("#"+target).fadeIn('slow').siblings(".tab-box").hide();
    return false;
  });

  $('.insta-wrapp-inner').slick({
    dots: false,
    infinite: true,
    speed: 300,
    slidesToShow:4,
    slidesToScroll:1,
    autoplay: false,
     arrows: true,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
          arrows: false
        }
      }
    ]
  });
   $(function () {
        $('.popup-modal').magnificPopup({
          type: 'inline',
          preloader: false,
          focus: '#username',
          modal: true
        });
        $(document).on('click', '.popup-modal-dismiss', function (e) {
          e.preventDefault();
          $.magnificPopup.close();
        });
      });

  $('.lookbook .product__content').slick({
    dots: true,
    infinite: true,
    arrows: true,
    speed: 300,
    slidesToShow:1,
    slidesToScroll:1,
    fade: true,
    cssEase: 'linear',
    adaptiveHeight: true,
    autoplay: true,
    autoplaySpeed: 3000
  });
           
   if($('.ColorVariantDD').length > 0){
      $('.ColorVariantDD .swatch.color .header span.hasselcolor').text("Selected "+$('.ColorVariantDD .img.active').attr('data-color'));
   }
});